import { ChangeEvent } from "react";

export const stripNonAlphanumeric = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
    return event;
};
